import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { DashboardDataType } from 'Types/admin/admin'

interface InitialStateProps {
  dashboardDataType: DashboardDataType
}

const initialState: InitialStateProps = {
  dashboardDataType: 'SERVICE_INCOME',
}

const adminDashboardSlice = createSlice({
  name: 'adminDashboardSlice',
  initialState,
  reducers: {
    setDashboardDataType: (state, action: PayloadAction<DashboardDataType>) => {
      state.dashboardDataType = action.payload
    },
    resetDashboardDataType: (state) => {
      state.dashboardDataType = 'SERVICE_INCOME'
    },
  },
})

const { actions } = adminDashboardSlice
export const { setDashboardDataType, resetDashboardDataType } = actions
export default adminDashboardSlice.reducer
